import { useQuery } from '@apollo/client';
import MaxoptraOrdersQuery from '../../../graphql/queries/sales/MaxoptraOrdersQuery.graphql';
import React, { useState } from 'react';
import { Spinner, SpinnerSize } from '@fluentui/react/lib/Spinner';
import EditableDataGrid from '../../../components/EditableDataGrid';
import DateTimeFormatter from '../../../components/grid-addons/formatters/DateTimeFormatter';
import { TrackingDetailsForOrderReference } from './TrackingDetails';
import {
  IMaxoptraOrder,
  IMaxoptraOrdersQueryResult,
  IMaxoptraOrdersQueryVariables,
} from '../../../graphql/schema/p4types';
import { default as Form } from '../../../components/connectedForm';

const MaxoptraTab = ({ salesOrderId }: { salesOrderId: number }) => {
  const { loading, data, refetch } = useQuery<IMaxoptraOrdersQueryResult, IMaxoptraOrdersQueryVariables>(
    MaxoptraOrdersQuery,
    {
      fetchPolicy: 'network-only',
      variables: {
        salesOrderId,
      },
    }
  );
  const [selectedRow, setSelectedRow] = useState<number | undefined>(undefined);

  const orders: [IMaxoptraOrder] = (data?.data as [IMaxoptraOrder]) || [];

  return (
    <Form.Row>
      <Form.Fieldset cols={1}>
        {loading ? (
          <Spinner size={SpinnerSize.large} />
        ) : (
          <>
            <EditableDataGrid
              columns={[
                {
                  name: 'Reference',
                  key: 'reference',
                },
                {
                  name: 'Status',
                  key: 'maxoptraOrderStatus',
                },
                {
                  name: 'Dispatch Document Number',
                  key: 'dispatchInstruction.documentNumber',
                },
                {
                  name: 'Last Notified',
                  key: 'lastNotifiedAt',
                  formatter: DateTimeFormatter,
                },
                {
                  name: 'Created By',
                  key: 'createdBy',
                },
              ]}
              onRowClick={setSelectedRow}
              listData={orders}
              rowsCount={orders.length}
              autoContentHeight
            />
            {selectedRow !== undefined && orders[selectedRow] ? (
              <TrackingDetailsForOrderReference
                orderReference={orders[selectedRow].reference!}
                maxoptraOrdersRefetchQuery={refetch}
              />
            ) : null}
          </>
        )}
      </Form.Fieldset>
    </Form.Row>
  );
};

export default MaxoptraTab;
